import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import {SwitchFilter} from "../buttons/SwitchFilter";
import {ConfigColumnsWidget} from "./ConfigColumnsWidget";
import {LabelsFilterButton} from "./LabelsFilterButton";
import {Spinner} from "../Spinner";
import {DashboardPlatformFilter} from "./DashboardPlatformFilter";
import {ViewInsightsButtonAndModal} from "./ViewInsightsButtonAndModal";
import { withTranslation } from 'react-i18next';
import {anchorAttr} from "../../guides/anchors";

class DashboardFiltersComponent extends Component {
    constructor(props) {
        super(props);

        this.handleTextFilterChange = this.handleTextFilterChange.bind(this);
        this.handleClearTextFilter = this.handleClearTextFilter.bind(this);
        this.handleToggleIssuesOnly = this.handleToggleIssuesOnly.bind(this);
        this.handleLabelsFilterChange = this.handleLabelsFilterChange.bind(this);

        this.state = {
            textFilter: this.props.textFilter,
            issuesOnly: this.props.issuesOnly,
            labelsFilter: this.props.labelsFilter,
            platformFilter: this.props.platformFilter
        };
    }

    componentDidUpdate(prevProps) {
        // Verificar si cada propiedad relevante ha cambiado
        if (prevProps.textFilter !== this.props.textFilter) {
            this.setState({ textFilter: this.props.textFilter });
        }

        if (prevProps.issuesOnly !== this.props.issuesOnly) {
            this.setState({ issuesOnly: this.props.issuesOnly });
        }

        if (!this.areArraysEqual(prevProps.labelsFilter, this.props.labelsFilter)) {
            this.setState({ labelsFilter: this.props.labelsFilter });
        }

        if (prevProps.platformFilter !== this.props.platformFilter) {
            this.setState({ platformFilter: this.props.platformFilter });
        }
    }

    areArraysEqual(arr1, arr2) {
        // Si ambas son nulas o ambas son arrays vacíos, son iguales
        if (!arr1 && !arr2) return true;
        if (arr1.length !== arr2.length) return false;

        // Verifica que cada elemento coincida
        return arr1.every((value, index) => value === arr2[index]);
    }

    handleTextFilterChange(event) {
        const inputValue = event.target.value;
        this.props.onTextFilterChange(inputValue);
    }

    handleClearTextFilter(event) {
        event.preventDefault();
        const emptyInput = '';
        this.props.onTextFilterChange(emptyInput);
    }

    handleToggleIssuesOnly(event) {
        const isOn = event.target.checked;
        this.props.onToggleIssuesOnly(isOn);
    }

    handleLabelsFilterChange(selectedLabels) {
        this.props.onLabelsFilterChange(selectedLabels);
    }

    handleRemoveFilteredLabel(removedLabel) {
        const remainingLabels = this.props.labelsFilter.filter((label) => {
            return label !== removedLabel;
        });
        this.handleLabelsFilterChange(remainingLabels);
    }

    renderFilteredLabels() {
        return this.props.labelsFilter.map((label) =>
            <span className="react-tagsinput-tag" key={label}>
                {label}
                <a href="#!" className="react-tagsinput-remove"
   onClick={() => this.handleRemoveFilteredLabel(label)}>
                    <span className="sr-only">x</span>
                </a>
            </span>
        );
    }


    renderDownloadButton() {
        const { t } = this.props;
        if (this.props.isDownloading) {
            return <Spinner color="positive small"/>;
        } else {
            return <button title={t('dashboard.export_dashboard')} onClick={this.props.onDownloadDashboardData}
                           className="dashboard-header-option">
                <FaIcon iconName="download"/>
                <p className="header-option-label">{t('dashboard.export')}</p>
            </button>
        }
    }

    renderSyncAllButton() {
        if (!this.props.bulkUserBusinessUnitsSyncEnabled) {
            return null;
        }
        
        const { t } = this.props;
        return (
            <button 
                type="button"
                title={t('dashboard.sync_all_control_lines')} 
                onClick={this.props.onSyncAllBusinessUnits}
                className="dashboard-header-option not-synced">
                <FaIcon iconName="sync-alt" style={{fontSize: '0.85em'}}/>
                <p className="header-option-label">{t('dashboard.sync_all')}</p>
            </button>
        );
    }

    render() {
        const { t } = this.props;
        return (
            <form className="filter-options" {...anchorAttr('dashboard_filters')}>
                <DashboardPlatformFilter
                    onPlatformFilterChange={this.props.onPlatformFilterChange}
                    platformFilter={this.state.platformFilter}
                />
                <div className="filter-input">
                    <label><FaIcon iconName="search"/></label>
                    <input name="budget" type="text" placeholder={t('dashboard.search_placeholder')}
                           onChange={this.handleTextFilterChange} value={this.state.textFilter}/>
                    <button className="filter-clear" onClick={this.handleClearTextFilter}>
                        <FaIcon iconName="times-circle"/>
                    </button>
                </div>
                <div className="filter-input">
                    {this.renderFilteredLabels()}
                </div>
                <LabelsFilterButton
                    onApplyFilter={this.handleLabelsFilterChange}
                    selectedLabels={this.state.labelsFilter}
                />
                <ConfigColumnsWidget
                    activeColumns={this.props.activeColumns}
                    activeColumnsSetId={this.props.activeColumnsSetId}
                    handleColumnStateChange={this.props.handleColumnStateChange}
                    onColumnsPositionChange={this.props.onColumnsPositionChange}
                    columnsSets={this.props.columnsSets}
                    onSelectColumnSet={this.props.onSelectColumnSet}
                    onSaveColumnSet={this.props.onSaveColumnSet}
                    onDeleteColumnSet={this.props.onDeleteColumnSet}
                    flexIndicators={this.props.flexIndicators}
                    ga4Indicators={this.props.ga4Indicators}
                    ecommerceIndicators={this.props.ecommerceIndicators}
                    paidMediaIndicators={this.props.paidMediaIndicators}
                    metaIndicators={this.props.metaIndicators}
                    googleIndicators={this.props.googleIndicators}
                    tiktokIndicators={this.props.tiktokIndicators}
                    customMetrics={this.props.customMetrics}
                    customMetricIndicators={this.props.customMetricIndicators}
                    canEditFlexIndicators={this.props.canEditFlexIndicators}
                />
                {this.renderModuleInsightsComponents()}
                {this.renderDownloadButton()}
                {this.renderSyncAllButton()}
                <SwitchFilter label={t('dashboard.view_only_urgent')} onChange={this.handleToggleIssuesOnly}
                              name="issues" checked={this.state.issuesOnly}/>
            </form>
        )
    }

    renderModuleInsightsComponents() {
        if(this.props.moduleInsightsEnabled !== true)
            return;

        return <ViewInsightsButtonAndModal/>;
    }
}

export const DashboardFilters = withTranslation()(DashboardFiltersComponent);

